/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SavedRx } from '../models/SavedRx';
import type { SavedRxDeleteInput } from '../models/SavedRxDeleteInput';
import type { SavedRxInput } from '../models/SavedRxInput';
import type { SavedRxName } from '../models/SavedRxName';
import type { SavedRxRenameAndSaveInput } from '../models/SavedRxRenameAndSaveInput';
import type { SavedRxRenameInput } from '../models/SavedRxRenameInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SavedrxService {
    /**
     * Find a prescription.
     * Find a prescription.
     * @param fileName
     * @param companyId
     * @returns SavedRx The found prescription.
     * @throws ApiError
     */
    public static savedRxControllerGetSavedRx(
        fileName: string,
        companyId?: string,
    ): CancelablePromise<SavedRx> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/savedrx/{fileName}/get',
            path: {
                'fileName': fileName,
            },
            query: {
                'companyID': companyId,
            },
            errors: {
                404: `Prescription not found.`,
            },
        });
    }
    /**
     * List prescriptions.
     * List prescriptions.
     * @param companyId
     * @returns SavedRxName The requested prescriptions.
     * @throws ApiError
     */
    public static savedRxControllerGetSavedRxList(
        companyId?: string,
    ): CancelablePromise<Array<SavedRxName>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/savedrx/get/list',
            query: {
                'companyID': companyId,
            },
        });
    }
    /**
     * Create a new prescription.
     * Create a new prescription.
     * @param requestBody
     * @returns SavedRx The created prescription.
     * @throws ApiError
     */
    public static savedRxControllerUpsertSavedRx(
        requestBody: SavedRxInput,
    ): CancelablePromise<SavedRx> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/savedrx/upsert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Company not found.`,
            },
        });
    }
    /**
     * Delete an existing prescription.
     * Delete an existing prescription.
     * @param requestBody
     * @returns any Was the deletion successful?.
     * @returns boolean
     * @throws ApiError
     */
    public static savedRxControllerDeleteSavedRx(
        requestBody: SavedRxDeleteInput,
    ): CancelablePromise<any | boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/savedrx/delete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    public static savedRxControllerRenameSavedRx(
        requestBody: SavedRxRenameInput,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/savedrx/rename',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Rename an existing prescription.
     * Rename an existing prescription.
     * @param requestBody
     * @returns any Was the renaming successful?.
     * @returns boolean
     * @throws ApiError
     */
    public static savedRxControllerRenameAndSaveSavedRx(
        requestBody: SavedRxRenameAndSaveInput,
    ): CancelablePromise<any | boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/savedrx/renameAndSave',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `A prescription by the given new file name already exists.`,
            },
        });
    }
}
